import { render, staticRenderFns } from "./OrderSuccessfullyUpdated.vue?vue&type=template&id=a499a4ca"
import script from "./OrderSuccessfullyUpdated.vue?vue&type=script&lang=js"
export * from "./OrderSuccessfullyUpdated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports